import "./form.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const FormText = props => <div className={`formText${props.alignRight ? " alignRight" : ""}`}>{props.children}</div>;

FormText.propTypes = {
  children: PropTypeShapes.elementOrArrayOrString.isRequired,
  alignRight: PropTypes.bool
};

export default FormText;
